import { ApolloLink } from "@apollo/client";
import { LertamRCFormat } from "./utils";
import CryptoJS from "crypto-js";

const decryptLink = new ApolloLink((operation, forward) => {
  // if (process.env.NODE_ENV !== "production") return forward(operation);
  return forward(operation).map((data: any) => {
    let encrypted = data.data.response;
    let decrypted = CryptoJS.AES.decrypt(encrypted, "password", {
      format: LertamRCFormat,
    });
    let result: any = decodeURIComponent(decrypted.toString(CryptoJS.enc.Utf8));
    result = JSON.parse(result);
    if (typeof result === "string") result = JSON.parse(result);
    return { data: result };
  });
});

export default decryptLink;
